import { useEffect, useState } from 'react';

// Tracks window.innerWidth for components that need to react to viewport
// size (e.g. auto-collapsing sidebars on narrow screens). No debounce —
// resize listeners here are cheap (a single setState), and debouncing would
// just add a perceptible lag to the sidebar collapse/expand.
export function useViewportWidth(): number {
  const [width, setWidth] = useState(() => window.innerWidth);

  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return width;
}
